<template lang="pug">
  //- v-layout(justify-center :style="{position: 'fixed', top: localValue ? '0' : '64px'}")#logo--holder.smooth
  //-   v-avatar(color="white" :size="localValue ? 96 : 256").smooth
  //-     v-img(alt="iamActive logo" :src="require('@/assets/logo.svg')")#logo
  v-layout(row wrap)
    v-flex(xs12)
      v-card(:style="{paddingTop: '364px'}")
        v-layout(justify-center)
          v-flex.text-xs-center.secondary--text
            h2.display-1: strong Connect your systems in an industry 4.0 way
            p.subtitle-1 Exchange data between utilities, systems and machines, as if it were one system.
            v-layout(wrap align-center justify-space-around style="max-width:680px;margin:0 auto")
              v-flex(shrink).text-xs-left
                div
                  v-icon(left) mdi-check
                  span.title On-premise
                div
                  v-icon(left) mdi-check
                  span.title GDPR Compliant
              v-flex(shrink).text-xs-left
                div
                  v-icon(left) mdi-check
                  span.title Self-configurable
                div
                  v-icon(left) mdi-check
                  span.title Caching
            v-btn(color="secondary" large v-if="showWatchBtn").my-4
              v-icon(left color="white") mdi-play
              span Watch how
            div(v-else).my-4
</template>
<script>
export default {
  props: ["offset"],
  data: () => ({
    showWatchBtn: false
  })
};
</script>